import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueAnalytics from 'vue-analytics'
import VueLazyload from 'vue-lazyload'
import VueScrollReveal from 'vue-scroll-reveal'
import vueHeadful from 'vue-headful'

Vue.config.productionTip = false

Vue.filter('parseTag', function (tag) {
  switch (tag) {
    // case 'ui': return 'UI design'
    // case 'ux': return 'UX thinking'
    case 'motion': return 'motion'
    case 'ui/ux': return 'UI/UX'
    case 'gd': return 'graphic design'
    case 'dev': return 'development'
    case 'all': return 'all'
  }
})

const isProd = process.env.NODE_ENV === 'production'
Vue.use(VueAnalytics, {
  id: 'UA-78298612-1',
  router,
  debug: {
    enabled: !isProd,
    sendHitTask: isProd
  }
})

// console.log(isProd)

Vue.use(VueScrollReveal, {
  class: 'v-scroll-reveal', // A CSS class applied to elements with the v-scroll-reveal directive; useful for animation overrides.
  duration: 800,
  scale: 1,
  distance: '10px',
  mobile: false,
  cleanup: true
})

Vue.use(VueLazyload, {
  preLoad: 1.3,
  loading: '/img/icons/loading.svg',
  attempt: 1
})

Vue.component('vue-headful', vueHeadful)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
